import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { VehicleGroupApiModel } from 'app/models/vehicle-groups-api.model';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable({ providedIn: 'root' })
export class MwVehicleGroupsApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  getVehicleGroups(
    options?: MwLoadOptions
  ): Observable<MwPayloadModel<VehicleGroupApiModel[]>> {
    let query = options ? this.loadOptionsService.buildQuery(options) : '';
    query = query.length ? `?${query}` : query;
    return this.http.authGet<MwPayloadModel<VehicleGroupApiModel[]>>(
      `/integration/v1/Companies/{companyId}/VehicleGroups${query}`
    );
  }

  createVehicleGroup(
    vehicleGroup: VehicleGroupApiModel
  ): Observable<VehicleGroupApiModel> {
    return this.http.authPost<VehicleGroupApiModel>(
      `/integration/v1/Companies/{companyId}/VehicleGroups`,
      {
        body: vehicleGroup,
      }
    );
  }

  updateVehicleGroup(
    vehicleGroup: VehicleGroupApiModel
  ): Observable<VehicleGroupApiModel> {
    return this.http.authPut<VehicleGroupApiModel>(
      `/integration/v1/Companies/{companyId}/VehicleGroups`,
      {
        body: vehicleGroup,
      }
    );
  }

  deleteVehicleGroup(vehicleGroup: VehicleGroupApiModel): Observable<any> {
    return this.http.authDelete<VehicleGroupApiModel>(
      `/integration/v1/Companies/{companyId}/VehicleGroups`,
      {
        body: vehicleGroup,
      }
    );
  }

  deleteVehicleGroupsList(
    vehicleGroups: VehicleGroupApiModel[]
  ): Observable<any> {
    return this.http.authDelete<any>(
      `/integration/v1/Companies/{companyId}/VehicleGroups/All`,
      { body: vehicleGroups }
    );
  }
}
